import {StagingTitelineAppPowerPack} from "../types/StagingTitelineAppPowerPack";
import {PowerPackData} from "../types/PowerPackData";
import { getApiUrl } from '../config/api';

export const fetchPowerPackByPid = async (pid?: number, aid: number = -1): Promise<PowerPackData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelinePowerPack/GetPowerPackByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });


        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No groutings found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching groutings for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppPowerPack[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((powerPack) => powerPack.DataSource === aid.toString());
        }

        return backendData.map((power_pack) => ({
            key: power_pack.PowId,
            pow_id: power_pack.PowId,
            pid: power_pack.Pid,
            time_from: power_pack.TimeFrom,
            time_to: power_pack.TimeTo,
        }));

    } catch (error) {
        console.error("Error in fetchPowerPackByPid API call:", error);
        return [];
    }
};

export const addPowerPackRow = async (powerPackRow: PowerPackData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelinePowerPack/AddPowerPack');

    const payload = [
        {
            Pid: powerPackRow.pid,
            TimeFrom: powerPackRow.time_from,
            TimeTo: powerPackRow.time_to,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (response.ok) {
            console.log("Power Pack row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add Power Pack row to cloud:",
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in AddPowerPackRow API call:", error);
        return false;
    }
};

export const updatePowerPackRow = async (pow_id: number, updatedRow: PowerPackData) => {
    const apiUrl = getApiUrl(`/api/TitelinePowerPack/UpdatePowerPackByPowId/${pow_id}`);

    const payload = {
        TimeFrom: updatedRow.time_from,
        TimeTo: updatedRow.time_to,
    };

    console.log(`Payload for updating Power Pack row:`, payload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (response.ok) {
            console.log(`Power Pack row with PowId ${pow_id} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update Power Pack row with PowId ${pow_id}:`,
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in UpdatePowerPackRow API call:", error);
        return false;
    }
};

export const deletePowerPackByPowId = async (pow_id: number) => {
    const apiUrl = getApiUrl(`/api/TitelinePowerPack/DeletePowerPackByPowId/${pow_id}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeletePowerPackByPowId API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete Power Pack row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in DeletePowerPackByPowId API call:", error);
        return false;
    }
};